import React from "react";
import { Box } from "./box";

export const Container = ({ css, width, ...props }) => {
  return (
    <Box
      {...props}
      css={{
        paddingLeft: "24px",
        paddingRight: "24px",
        maxWidth: `${width}px`,
        minWidth: "300px",
        ...(css || {}),
      }}
    />
  );
};
